import { render, staticRenderFns } from "./component-rank.vue?vue&type=template&id=23b6db17&scoped=true&"
import script from "./component-rank.vue?vue&type=script&lang=js&"
export * from "./component-rank.vue?vue&type=script&lang=js&"
import style0 from "./component-rank.vue?vue&type=style&index=0&id=23b6db17&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b6db17",
  null
  
)

export default component.exports